// Chart add-on entry for @a-safe-digital/conek-ui.
//
// Charts::* components (and Ui::MetricTileComponent with sparkline_data)
// bind `ui--chart`, whose controller lazy-imports "chart.js/auto" (~441 KB unminified, ~211 KB minified).
// esbuild hosts that bundle without --splitting INLINE that dynamic import,
// so as long as the controller was reachable from the default registration
// manifest, every host paid for chart.js whether or not it rendered a chart.
//
// The controller therefore ships in this SEPARATE entry, reachable only from
// a host entry point that chart-bearing pages load. Vite hosts get real code
// splitting and may register it from their main graph; esbuild hosts should
// emit a second entry file and include it only where charts render.
//
// Load order: the host's own Application instance is shared — register the
// chart controller on the SAME application you passed to
// registerConekUiControllers (exported `application` in the host entry).
import ChartController from "./controllers/ui/chart_controller"

export { ChartController as default }

export function registerConekUiChartController(application) {
  application.register("ui--chart", ChartController)
}
